import axios from 'axios';

//export const http = axios.create({ baseURL: 'http://api.checkpoint.recco.com.br/api' })
export const http = axios.create({ baseURL: 'https://qualipoint-ws.uses.com.br/api' })
//export const http = axios.create({ baseURL: 'http://qualipointrecco-ws/api' })
//export const http = axios.create({ baseURL: 'http://192.168.1.17/qualipointrecco-ws/public_html/api' }) //by celular.



// WEBPACK FOOTER //
// ./src/http.js